import { useMemo } from 'react';

import { useAccount } from 'modules/account/hooks/useAccount';
import { useAuth } from 'modules/auth/hooks/useAuth';

import { PRIMARY_JWT_INDEX } from '../const';
import { getAllowedAddProjectTokenIndex } from '../utils/getAllowedAddProjectTokenIndex';
import { useJWTManagerPermissions } from './useJWTManagerPermissions';
import { useJWTs } from './useJWTs';

export const useJWTsManager = () => {
  const {
    allowedJWTsCount: maxTokensLimit,
    hasReadAccess: shouldShowTokenManager,
    hasWriteAccess,
  } = useJWTManagerPermissions();

  const { isLoggingIn } = useAuth();
  const { group } = useAccount();

  const skipFetching = isLoggingIn || !shouldShowTokenManager;

  const {
    jwts,
    loading: jwtsLoading,
    state: { isError, isSuccess, isUninitialized },
  } = useJWTs({ group, skipFetching });

  const allowedAddProjectTokenIndex = useMemo(
    () => getAllowedAddProjectTokenIndex(maxTokensLimit, jwts),
    [maxTokensLimit, jwts],
  );

  const enableAddProject =
    jwts.length < maxTokensLimit &&
    allowedAddProjectTokenIndex > PRIMARY_JWT_INDEX &&
    hasWriteAccess;

  return {
    allowedAddProjectTokenIndex,
    enableAddProject,
    isLoaded: isSuccess || isError,
    isUninitialized,
    jwts,
    jwtsLoading,
    shouldShowTokenManager,
  };
};
